<header class="header">
	<div class="header__wrapper">
		<div class="title">
			<h1 class="title__headline">{{ 'TITLE' | translate }}</h1>
		</div>
		<div class="logo">
			<img src="assets/images/logo.svg" alt="Hess" class="logo__image" />
		</div>
	</div>
</header>
<div class="subtitlebar">
	<h2 class="subtitlebar__title">{{ 'SEND.TITLE' | translate }}</h2>
</div>
<div class="send">
	<div class="loading" *ngIf="state == 'transfer'">
		<div class="loading__wrapper" long-press (longpress)="onBackToForm()">
			<div class="loading__spinner"></div>
			<i class="fa fa-upload loading__icon loading__icon--upload"></i>
		</div>
		<div class="loading__text">{{ 'SEND.PENDING' | translate }}</div>
	</div>
	<div class="loading" *ngIf="state == 'success'">
		<div class="loading__wrapper" (tap)="onBackToStage()">
			<div class="loading__spinner loading__spinner--success"></div>
			<i class="fa fa-check loading__icon loading__icon--success"></i>
		</div>
		<div class="loading__text loading__text--success">{{ 'SEND.SUCCESS' | translate }}</div>
	</div>
	<div class="loading" *ngIf="state == 'error'">
		<div class="loading__wrapper" (tap)="onBackToForm()">
			<div class="loading__spinner loading__spinner--error"></div>
			<i class="fa fa-times loading__icon loading__icon--error"></i>
		</div>
		<div class="loading__text loading__text--error">{{ 'SEND.ERROR' | translate }}</div>
	</div>
</div>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/send/send.component.html